/** 2–3 letter all-caps tokens from the API (e.g. VW, GM, PD). */
function isShortUppercaseAcronym(word: string): boolean {
  const len = word.length;
  if (len < 2 || len > 3) return false;
  for (let i = 0; i < len; i++) {
    const code = word.charCodeAt(i);
    if (code < 65 || code > 90) return false;
  }
  return true;
}

/** Display-only: title-style biller label (raw API/store values unchanged). */
export function formatBillerDisplayName(name: string): string {
  const trimmed = String(name ?? "").trim();
  if (!trimmed) return trimmed;

  const smallWords = new Set(["of", "and", "the", "for", "in", "on", "at", "to", "a", "an"]);

  return trimmed
    .split(/\s+/)
    .map((word, index) => {
      if (!word) return word;
      const lower = word.toLowerCase();
      if (index > 0 && smallWords.has(lower)) return lower;
      // Keep short acronyms from API (e.g. VW, GM, PD).
      if (isShortUppercaseAcronym(word)) return word;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
}
